import type { ResourceLanguage } from "i18next";

import { Tk } from "../translation-key";
import { pluralForSlavic, tk } from "../utils";

const RESOURCES = {
  translation: {
    EN: "англ",
    UK: "укр",
    DE: "нім",
    SK: "слов",
    RU: "рос",
    ENGLISH: "англійська",
    UKRAINIAN: "українська",
    GERMAN: "німецька",
    SLOVAK: "словацька",
    RUSSIAN: "російська",
    ORDER_ACCEPTANCE: "прийом замовлень",
    INTRODUCTION: "вступ",
    CALCULATOR: "калькулятор",
    PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND: "професійні послуги з переїзду у Швейцарії",
    RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET:
      "надійні вантажники, досвідчені водії та найкраща ціна на ринку",
    CALCULATE_THE_COST: "розрахуйте вартість",
    SUPPORT: "підтримка",
    RELIABLE_SERVICE: "надійний сервіс",
    WHY_CUSTOMERS_CHOOSE_US: "чому клієнти обирають нас",
    FAVORABLE_PRICES: "вигідні ціни",
    THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES:
      "найкращі ціни на ринку без прихованих платежів",
    FAST_CAR_DELIVERY: "швидка подача авто",
    TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES: "транспорт прибуде протягом 30-60 хвилин",
    EXPERIENCED_LOADERS: "досвідчені вантажники",
    QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE:
      "кваліфіковані співробітники з великим досвідом роботи",
    GUARANTEE_OF_PRESERVATION: "гарантія збереження",
    YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE: "ваші речі в безпеці протягом усього переїзду",
    OUR_SERVICES: "наші послуги",
    WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES:
      "пропонуємо повний спектр послуг для квартирного, офісного та промислового переїзду",
    APARTMENT_MOVING: "квартирний переїзд",
    OFFICE_RELOCATION: "офісний переїзд",
    INDUSTRIAL_RELOCATION: "промисловий переїзд",
    MORE_DETAILS: "детальніше",
    MOVING_COST: "вартість переїзду",
    FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS:
      "гнучка система ціноутворення для різних замовлень",
    MINIMUM: "мінімальний",
    FROM_PRICE: "від {{price}}",
    CARGO_GAZELLE: "вантажна газель",
    TRUCK: "вантажівка",
    T: "т",
    NUMBER_OF_LOADERS: "кількість вантажників",
    POPULAR: "популярний",
    PRICE_FOR_A_1_ROOM_APARTMENT: "ціна за 1-кімнатну квартиру",
    PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M: "ціна за будинок площею до 100 м²",
    PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M: "ціна за офіс площею до 50 м²",
    ORDER: "замовлення",
    [tk(Tk.ORDER, { plural: "one" })]: "замовлення",
    ...pluralForSlavic(Tk.ORDER, "замовлення"),
    [tk(Tk.ORDER, { partOfSpeech: "verb" })]: "замовити",
    COST_CALCULATOR: "калькулятор вартості",
    CALCULATE_THE_COST_OF_YOUR_MOVE: "розрахуйте вартість вашого переїзду",
    SELECT_SERVICES: "виберіть послуги",
    TRANSPORTATION: "транспортування",
    PACKING_THINGS: "упаковка речей",
    LOADING_UNLOADING: "завантаження/розвантаження",
    VEHICLE: "транспортний засіб",
    YOUR_ORDER: "ваше замовлення",
    TOTAL: "всього",
    OUR_CUSTOMERS_REVIEWS: "відгуки наших клієнтів",
    HOW_DO_WE_WORK: "як ми працюємо",
    PREPARATION: "підготовка",
    MOVING: "переїзд",
    YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES:
      "ви залишаєте заявку на сайті або телефонуєте. Наш менеджер зв'яжеться з вами протягом 15 хвилин",
    WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM:
      "ми розраховуємо вартість, узгоджуємо час, привозимо упаковочні матеріали та готуємо команду",
    OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS:
      "наші спеціалісти прибувають у призначений час, ретельно спаковують, завантажують та транспортують ваші речі",
    CONTACT_US: "зв'яжіться з нами",
    ADDRESS: "адреса",
    [tk(Tk.ADDRESS, { plural: "one" })]: "адреса",
    ...pluralForSlavic(Tk.ADDRESS, "адреси"),
    PHONE: "телефон",
    [tk(Tk.PHONE, { plural: "one" })]: "телефон",
    ...pluralForSlavic(Tk.PHONE, "телефони"),
    EMAIL: "електронна пошта",
    [tk(Tk.EMAIL, { case_: "genitive" })]: "електронної пошти",
    WORK_SCHEDULE: "графік роботи",
    SOCIAL_NETWORKS: "соціальні мережі",
    WRITE_TO_US: "напишіть нам",
    REQUEST_SUBJECT: "тема запиту",
    I_D_LIKE_TO_ORDER: "я хочу зробити замовлення",
    QUESTIONS_ABOUT_SERVICES: "запитання щодо послуг",
    OTHER: "інше",
    MESSAGE: "повідомлення",
    SEND: "надіслати",
    CONVENIENT_FAST_RELIABLE: "зручно, швидко, надійно",
    ALL_RIGHTS_RESERVED: "всі права захищені",
    THERE_WAS_AN_ERROR_LOADING_DATA: "під час завантаження даних сталася помилка",
    TRY_AGAIN: "спробувати ще раз",
    ORDER_A_MOVE: "замовити переїзд",
    CONTACT_PERSON: "контактна особа",
    FULL_NAME: "повне ім'я",
    CITY: "місто",
    FLOOR: "поверх",
    IS_THERE_AN_ELEVATOR: "чи є ліфт",
    DESCRIPTION_OF_CARGO: "опис вантажу",
    FROM_WHERE: "звідки",
    TO: "куди",
    SEND_AN_APPLICATION: "надіслати заявку",
    DOES_NOT_MATCH_FORMAT: "не відповідає формату {{format}}",
    NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED: "недостатньо символів, потрібен принаймні {{count}}",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "one" })]:
      "недостатньо символів, потрібен принаймні {{count}}",
    ...pluralForSlavic(
      Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED,
      "недостатньо символів, потрібно принаймні {{count}}",
    ),
    WHAT_IS_INCLUDED_IN_THE_SERVICE: "що входить до послуги",
    NO_INFORMATION_PROVIDED_AT_THIS_TIME: "наразі інформація не надана",
    MUST_BE_A_NUMBER: "має бути числом",
    MUST_BE_GREATER_THAN_N: "має бути більше ніж {{count}}",
    MUST_BE_AT_LEAST_N: "має бути щонайменше {{count}}",
    FIELD_CANNOT_BE_EMPTY: "поле не може бути порожнім",
    FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS: "поле має містити щонайменше {{count}} символ",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "one" })]:
      "поле має містити щонайменше {{count}} символ",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "few" })]:
      "поле має містити щонайменше {{count}} символи",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "many" })]:
      "поле має містити щонайменше {{count}} символів",
    FIELD_MUST_MATCH_FORMAT: "поле має відповідати формату {{format}}",
    FIELD_MUST_CONTAIN_A_NUMBER: "поле має містити число",
    VALUE_MUST_BE_GREATER_THAN_N: "значення має бути більше ніж {{count}}",
    MINIMUM_VALUE_IS_N: "мінімальне значення — {{count}}",
    FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER: "поле повинно містити не більше {{count}} символу",
    [tk(Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER, { plural: "one" })]:
      "поле повинно містити не більше {{count}} символу",
    ...pluralForSlavic(
      Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER,
      "поле повинно містити не більше {{count}} символів",
    ),
    VALUE_MUST_BE_LESS_THAN_N: "значення має бути менше ніж {{count}}",
    MAXIMUM_VALUE_IS_N: "максимальне значення — {{count}}",
    PICK_A_DATE: "оберіть дату",
    HOW_DID_YOU_HEAR_ABOUT_US: "як ви про нас дізналися",
    PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US: "будь ласка, розкажіть нам, як ви дізналися про нас",
    WEB_SEARCH: "веб-пошук",
    FRIEND_RECOMMENDATIONS: "рекомендації друзів",
    SOCIAL_MEDIA: "соціальні мережі",
    ADVERTISING: "реклама",
    GENDER: "стать",
    MALE: "чоловіча",
    FEMALE: "жіноча",
    UNDETERMINED: "невизначена",
    POSTAL_CODE: "поштовий індекс",
    BUILDING_TYPE: "тип будівлі",
    PRIVATE_HOUSE: "приватний будинок",
    APARTMENT: "квартира",
    OFFICE: "офіс",
    AREA: "площа",
    M: "м",
    NUMBER_OF_ROOMS: "кількість кімнат",
    IS_THERE_AN_ATTIC: "чи є горище",
    IS_THERE_A_BASEMENT: "чи є підвал",
    PLANNED_MOVING_DATE: "запланована дата переїзду",
    SELECTED_SERVICES: "вибрані послуги",
    MENU: "меню",
    DASHBOARD: "дашборд",
    DOCUMENTATION: "документація",
    ADMINISTRATOR: "адміністратор",
    A: "а",
    MY_PROFILE: "мій профіль",
    ORDER_MANAGEMENT: "управління замовленнями",
    SERVICE_MANAGEMENT: "управління послугами",
    USER_MANAGEMENT: "управління користувачами",
    NEW: "новий",
    [tk(Tk.NEW, { plural: "one" })]: "новий",
    ...pluralForSlavic(Tk.NEW, "нові"),
    ...pluralForSlavic(Tk.NEW, "нового", { plural: "one", case_: "genitive" }),
    ...pluralForSlavic(Tk.NEW, "нових", { case_: "genitive" }),
    COMPLETED: "виконаний",
    [tk(Tk.COMPLETED, { plural: "one" })]: "виконаний",
    ...pluralForSlavic(Tk.COMPLETED, "виконані"),
    ...pluralForSlavic(Tk.COMPLETED, "виконаного", { plural: "one", case_: "genitive" }),
    ...pluralForSlavic(Tk.COMPLETED, "виконаних", { case_: "genitive" }),
    REVENUE: "дохід",
    SINCE_YESTERDAY: "з учорашнього дня",
    LATEST_ORDERS: "останні замовлення",
    SHOW_ALL: "показати всі",
    ID: "ід",
    CLIENT: "клієнт",
    DATE: "дата",
    SUM: "сума",
    STATUS: "статус",
    IN_PROGRESS: "у процесі",
    ASSIGNED: "призначений",
    CANCELLED: "скасований",
    ANNUAL_REVENUE: "річний дохід",
    ADD_ORDER: "додати замовлення",
    FILTER: "фільтр",
    WITH_ELEVATOR: "з ліфтом",
    WITHOUT_ELEVATOR: "без ліфта",
    EDIT: "редагувати",
    DELETE: "видалити",
    YES: "так",
    NO: "ні",
    ADD_A_SERVICE: "додати послугу",
    NAME: "ім'я",
    [tk(Tk.NAME, { animateness: "inanimate" })]: "назва",
    CATEGORY: "категорія",
    [tk(Tk.CATEGORY, { plural: "one" })]: "категорія",
    ...pluralForSlavic(Tk.CATEGORY, "категорії"),
    [tk(Tk.CATEGORY, { case_: "genitive" })]: "категорії",
    [tk(Tk.CATEGORY, { case_: "accusative" })]: "категорію",
    PRICE: "ціна",
    ACTIVE: "активний",
    [tk(Tk.ACTIVE, { gender: "feminine" })]: "активна",
    INACTIVE: "неактивний",
    [tk(Tk.INACTIVE, { gender: "feminine" })]: "неактивна",
    ADD_USER: "додати користувача",
    EMPLOYEE: "працівник",
    USER: "користувач",
    [tk(Tk.USER, { plural: "one" })]: "користувач",
    ...pluralForSlavic(Tk.USER, "користувачі"),
    [tk(Tk.USER, { case_: "accusative" })]: "користувача",
    ROLE: "роль",
    [tk(Tk.ROLE, { plural: "one" })]: "роль",
    ...pluralForSlavic(Tk.ROLE, "ролі"),
    VIEW: "переглянути",
    ORDER_INFORMATION: "інформація про замовлення",
    CREATION_DATE: "дата створення",
    TOTAL_COST: "загальна вартість",
    QUANTITY: "кількість",
    INFORMATION_NOT_PROVIDED: "інформація не надана",
    CHANGE_STATUS: "змінити статус",
    ACTIONS: "дії",
    PRINT: "друк",
    STATUS_SUCCESSFULLY_CHANGED: "статус успішно змінено",
    FAILED_TO_CHANGE_STATUS: "не вдалося змінити статус",
    THIS_ORDER_WAS_NOT_FOUND: "це замовлення не знайдено",
    SERVICE_CATEGORY_MANAGEMENT: "управління категоріями послуг",
    DESCRIPTION: "опис",
    ADD_CATEGORY: "додати категорію",
    THIS_ACTION_CANNOT_BE_UNDONE: "цю дію не можна скасувати",
    NO_RECORDS_FOUND_IN_THE_DATABASE: "у базі даних не знайдено жодних записів",
    NUMBER: "номер",
    SIZE: "розмір",
    CREATE: "створити",
    LANGUAGE: "мова",
    SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN:
      "виберіть мову, якою ви хочете надати дані для заповнення",
    SAVE: "зберегти",
    RESET: "скинути",
    IMAGE: "зображення",
    ADD: "додати",
    HYPERLINK: "гіперпосилання",
    CHANGES_SAVED_SUCCESSFULLY: "зміни успішно збережено",
    FAILED_TO_SAVE_CHANGES: "не вдалося зберегти зміни",
    SERVICE: "послуга",
    [tk(Tk.SERVICE, { plural: "one" })]: "послуга",
    ...pluralForSlavic(Tk.SERVICE, "послуги"),
    [tk(Tk.SERVICE, { case_: "genitive" })]: "послуги",
    [tk(Tk.SERVICE, { case_: "accusative" })]: "послугу",
    THE_DATE_MUST_NOT_BE_IN_THE_PAST: "дата не повинна бути в минулому",
    ORDER_REQUEST: "запит на замовлення",
    PASSWORD: "пароль",
    ADMINISTRATIVE_PANEL: "адміністративна панель",
    FORGOT_YOUR_PASSWORD: "забули пароль",
    REMEMBER_ME: "запам'ятати мене",
    SIGN_IN: "увійти",
    FAILED_TO_LOG_IN: "не вдалося увійти",
    AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER:
      "сталася неочікувана помилка, спробуйте ще раз пізніше",
    INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD: "неправильна адреса електронної пошти та/або пароль",
    SIGN_OUT: "вийти",
    FIRST_NAME: "ім'я",
    LAST_NAME: "прізвище",
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER:
      "ця адреса електронної пошти вже використовується іншим користувачем",
    SUBJECT: "тема",
    BODY: "тіло",
    SENDING_AN_EMAIL: "надсилання електронного листа",
    EMAIL_SENT_SUCCESSFULLY: "електронний лист успішно надіслано",
    SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST: "деякі з вибраних ролей не існують",
    INQUIRY: "запит",
    [tk(Tk.INQUIRY, { plural: "one" })]: "запит",
    ...pluralForSlavic(Tk.INQUIRY, "запити"),
    [tk(Tk.INQUIRY, { case_: "genitive" })]: "запиту",
    [tk(Tk.INQUIRY, { case_: "accusative" })]: "запит",
    FAILED_TO_LOAD_YOUR_DATA: "не вдалося завантажити ваші дані",
    ACCESS_TO_THE_PAGE_IS_DENIED: "доступ до сторінки заборонено",
    ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE:
      "лише адміністратори мають доступ до цієї сторінки",
    ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE:
      "лише адміністратори та співробітники мають доступ до цієї сторінки",
    YOU_ARE_ALREADY_LOGGED_IN: "ви вже ввійшли в систему",
    AUTHENTICATION_SESSION_EXPIRED: "сеанс автентифікації закінчився",
    ORDERED_SERVICES: "замовлені послуги",
    [tk(Tk.ORDERED_SERVICES, { case_: "genitive" })]: "замовлених послуг",
    THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT:
      "дата не повинна бути раніше поточного моменту",
    YOU_HAVE_NOT_SELECTED_ANY_SERVICES: "ви не вибрали жодної послуги",
    VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT: "значення має відповідати формату номера телефону",
    "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...":
      "введіть значення у міжнародному форматі номера телефону, тобто +, код країни та сам номер телефону (без пробілів), наприклад: +41791234567",
    ACCOUNT_LOGIN: "вхід до облікового запису",
    "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...":
      "професійна організація переїзду до/з квартири, офісу чи приватного будинку у Швейцарії. Швидко, безпечно та без проблем. Сплануйте свій переїзд разом з нами!",
    "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...":
      "переїзд у Швейцарії, переїзд квартири, переїзд офісу, переїзд приватного будинку, переїзд квартири, перевезення меблів у Швейцарії, послуги з переїзду",
    INQUIRY_MANAGEMENT: "управління запитами",
    RESOLVED: "вирішено",
    ADMINISTRATOR_COMMENT: "коментар адміністратора",
    RESOLVE: "вирішити",
    INQUIRY_RESOLUTION: "вирішення запиту",
    REVIEW_MANAGEMENT: "управління оглядами",
    RATING: "рейтинг",
    PROS: "плюси",
    CONS: "мінуси",
    TEXT: "текст",
    REVIEW: "відгук",
    [tk(Tk.REVIEW, { plural: "one" })]: "відгук",
    ...pluralForSlavic(Tk.REVIEW, "відгуки"),
    [tk(Tk.REVIEW, { case_: "genitive" })]: "відгуку",
    [tk(Tk.REVIEW, { case_: "accusative" })]: "відгук",
    FAILED_TO_OPEN_PRINT_WINDOW: "не вдалося відкрити вікно друку",
    NEW_ORDER: "нове замовлення",
    NEW_INQUIRY: "новий запит",
    NEW_REVIEW: "новий відгук",
    SOMETHING_HAPPENED: "щось сталося",
    MARK_AS_READ: "позначити як прочитане",
    FAILED_TO_MARK_NOTIFICATION_AS_READ: "не вдалося позначити сповіщення як прочитане",
    MARK_ALL_AS_READ: "позначити всі як прочитані",
    FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ: "не вдалося позначити всі сповіщення як прочитані",
    NOTIFICATION: "сповіщення",
    ORDER_CREATION: "створення замовлення",
    SERVICE_CREATION: "створення послуги",
    CATEGORY_CREATION: "створення категорії",
    USER_CREATION: "створення користувача",
    ORDER_CREATED: "замовлення створено",
    SERVICE_CREATED: "послугу створено",
    CATEGORY_CREATED: "категорію створено",
    USER_CREATED: "користувача створено",
    INQUIRY_CREATED: "запит створено",
    REVIEW_CREATED: "відгук створено",
    ORDER_REQUEST_CREATED: "запит на замовлення створено",
    FAILED_TO_CREATE_ORDER: "не вдалося створити замовлення",
    FAILED_TO_CREATE_SERVICE: "не вдалося створити послугу",
    FAILED_TO_CREATE_CATEGORY: "не вдалося створити категорію",
    FAILED_TO_CREATE_USER: "не вдалося створити користувача",
    FAILED_TO_CREATE_INQUIRY: "не вдалося створити запит",
    FAILED_TO_CREATE_REVIEW: "не вдалося створити відгук",
    FAILED_TO_CREATE_ORDER_REQUEST: "не вдалося створити запит на замовлення",
    ORDER_DELETED: "замовлення видалено",
    SERVICE_DELETED: "послугу видалено",
    CATEGORY_DELETED: "категорію видалено",
    USER_DELETED: "користувача видалено",
    REVIEW_DELETED: "відгук видалено",
    INQUIRY_DELETED: "запит видалено",
    FAILED_TO_DELETE_ORDER: "не вдалося видалити замовлення",
    FAILED_TO_DELETE_SERVICE: "не вдалося видалити послугу",
    FAILED_TO_DELETE_CATEGORY: "не вдалося видалити категорію",
    FAILED_TO_DELETE_USER: "не вдалося видалити користувача",
    FAILED_TO_DELETE_REVIEW: "не вдалося видалити відгук",
    FAILED_TO_DELETE_INQUIRY: "не вдалося видалити запит",
    ORDER_NOT_FOUND: "замовлення не знайдено",
    SERVICE_NOT_FOUND: "послугу не знайдено",
    CATEGORY_NOT_FOUND: "категорію не знайдено",
    USER_NOT_FOUND: "користувача не знайдено",
    REVIEW_NOT_FOUND: "відгук не знайдено",
    INQUIRY_NOT_FOUND: "запит не знайдено",
    NOTIFICATION_NOT_FOUND: "сповіщення не знайдено",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER: "Ви впевнені, що хочете видалити замовлення?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE: "Ви впевнені, що хочете видалити послугу?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY: "Ви впевнені, що хочете видалити категорію?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER: "Ви впевнені, що хочете видалити користувача?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW: "Ви впевнені, що хочете видалити відгук?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY: "Ви впевнені, що хочете видалити запит?",
    ORDER_EDITING: "редагування замовлення",
    SERVICE_EDITING: "редагування послуги",
    CATEGORY_EDITING: "редагування категорії",
    USER_EDITING: "редагування користувача",
    REVIEW_EDITING: "редагування відгуку",
    INQUIRY_EDITING: "редагування запиту",
    EDITING_ORDERED_SERVICES: "редагування замовлених послуг",
    FAILED_TO_PRINT_ORDER: "не вдалося надрукувати замовлення",
    FAILED_TO_SEND_EMAIL: "не вдалося надіслати електронного листа",
    FAILED_TO_SIGN_OUT: "не вдалося вийти",
    CONTACT: "контакт",
    [tk(Tk.CONTACT, { plural: "one" })]: "контакт",
    ...pluralForSlavic(Tk.CONTACT, "контакти"),
    [tk(Tk.CONTACT, { context: "infinitive" })]: "зв'язатися",
    YOU_HAVE_NO_NOTIFICATIONS: "у вас немає сповіщень",
    NO_REVIEWS_YET: "поки що немає відгуків",
    WRITE_A_REVIEW: "написати відгук",
    WRITING_A_REVIEW: "написання відгуку",
    ORDER_ID: "ІД замовлення",
    PAGE_NOT_FOUND: "сторінку не знайдено",
    "IT_LOOKS_LIKE_THE_PAGE_...":
      "Схоже, сторінка, яку ви шукаєте, перемістилася на нову адресу. Але не хвилюйтеся, ми допоможемо вам знайти дорогу назад!",
    HOME: "головна",
    RETURN_TO_THE_MAIN_PAGE: "повернутися на головну сторінку",
    CALCULATE: "розрахувати",
    CALCULATE_THE_COST_OF_MOVING: "розрахувати вартість переїзду",
    GO_TO: "перейти",
    PERSONAL_DATA_UPDATED: "персональні дані оновлено",
    FAILED_TO_UPDATE_PERSONAL_DATA: "не вдалося оновити персональні дані",
    ROLE_DATA_UPDATED: "дані ролі оновлено",
    FAILED_TO_UPDATE_ROLE_DATA: "не вдалося оновити дані ролі",
    PAID: "оплачене",
    UNPAID: "неоплачене",
    ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED:
      "приймаються лише зображення у форматах {{formats}}",
    FAILED_TO_SAVE_IMAGE: "не вдалося зберегти зображення",
    FAILED_TO_DELETE_PREVIOUS_IMAGE: "не вдалося видалити попереднє зображення",
    ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA: "Ви впевнені, що хочете очистити дані форми?",
    MAX: "макс",
    REVIEW_DETAILS: "подробиці відгуку",
    ORDER_NUMBER: "номер замовлення",
    "NO.": "№",
    OPEN_NAVIGATION_MENU: "відкрити меню навігації",
    CLOSE_NAVIGATION_MENU: "закрити меню навігації",
    PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU:
      "Будь ласка, надайте цю інформацію лише у випадку, якщо ви хочете, щоб ми зв’язалися з вами.",
    THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY: "Ця інформація не буде доступна публічно.",
    OPTIONAL: "необов'язковий",
    PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION:
      "будь ласка, надайте хоча б одну контактну інформацію",
    ORDER_DETAILS: "деталі замовлення",
    ORDER_SUMMARY: "зведення замовлення",
    CUSTOMER_SUPPORT: "клієнтська підтримка",
    APPROVED: "схвалено",
    REJECTED: "відхилено",
    APPROVE: "схвалити",
    DISAPPROVE: "відхилити",
    REVIEW_SUCCESSFULLY_APPROVED: "відгук успішно схвалено",
    FAILED_TO_APPROVE_REVIEW: "не вдалося схвалити відгук",
    MY_ORDERS: "мої замовлення",
    DELETE_ALL: "видалити все",
    "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...":
      "Це просто список замовлень, збережених на вашому пристрої, тож ви можете переглянути детальну інформацію про кожне з них у будь-який час.",
    "DELETING_A_SPECIFIC_OR_ALL_ORDERS...":
      "Видалення певного або всіх замовлень видаляє лише ці дані з вашого пристрою та не впливає на дані, що зберігаються в базі даних.",
    "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...":
      "Якщо вам потрібно змінити будь-яку інформацію про ваше замовлення або скасувати його, будь ласка, зв'яжіться з нами.",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS: "Ви впевнені, що хочете видалити всі замовлення?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N:
      "Ви впевнені, що хочете видалити замовлення №{{number}}?",
    YOU_HAVEN_T_CREATED_ANY_ORDERS_YET: "ви ще не створили жодних замовлень",
    "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...":
      "ваш відгук буде опубліковано після перевірки адміністратором",
    CHANGE_PASSWORD: "змінити пароль",
    PASSWORD_CHANGE: "зміна пароля",
    CURRENT_PASSWORD: "поточний пароль",
    NEW_PASSWORD: "новий пароль",
    REPEAT_NEW_PASSWORD: "повторіть новий пароль",
    PASSWORDS_DO_NOT_MATCH: "паролі не збігаються",
    PASSWORD_CHANGED: "пароль змінено",
    FAILED_TO_CHANGE_PASSWORD: "не вдалося змінити пароль",
    CURRENT_PASSWORD_IS_INCORRECT: "поточний пароль неправильний",
    INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION: "недостатньо прав для виконання цієї дії",
    CASH_PAYMENT_IS_POSSIBLE: "можлива оплата готівкою",
    WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS: "у нас є спеціальні пропозиції для пенсіонерів",
    WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS: "ми надаємо 10% знижку для студентів",
    ABOUT_US: "про нас",
    PASSWORD_RESET: "скидання пароля",
    "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...":
      "введіть адресу електронної пошти, пов’язану з вашим обліковим записом, і ми надішлемо вам електронного листа з новим паролем",
    PASSWORD_RESET_SUCCESSFUL: "скидання пароля успішне",
    AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS:
      "на вашу адресу надіслано електронного листа з новим паролем",
    FAILED_TO_SEND_PASSWORD_RESET_REQUEST: "не вдалося надіслати запит на скидання пароля",
    RESET_PASSWORD: "скинути пароль",
    AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND:
      "обліковий запис із зазначеною адресою електронної пошти не знайдено",
    ABOUT_US_CHAPTER_1_TITLE: "ВАШ ДІМ - НАША РОБОТА",
    ABOUT_US_CHAPTER_1_PARAGRAPH:
      "Ми гарантуємо, що ваш переїзд пройде гладко. Незалежно від того, чи ви переїжджаєте до нового міста, переїжджаєте у свій перший будинок, чи вам потрібно більше місця з родиною – <strong>ми зробимо ваш переїзд легким і, перш за все, безстресовим</strong>.",
    ABOUT_US_CHAPTER_2_TITLE: "ВАША КОМПАНІЯ - НАША РОБОТА",
    ABOUT_US_CHAPTER_2_PARAGRAPH_1:
      "<strong>Переїзд з компанією може бути великим викликом</strong>.",
    ABOUT_US_CHAPTER_2_PARAGRAPH_2:
      "Ось чому корисно мати поруч компетентного та досвідченого партнера. Ми спеціалізуємося на ефективному та з мінімальним простоєм у здійсненні корпоративних переїздів. Ви зосередьтеся на своєму основному бізнесі, а ми подбаємо про решту.",
    ABOUT_US_CHAPTER_3_TITLE: "УТИЛІЗАЦІЯ",
    ABOUT_US_CHAPTER_3_PARAGRAPH_1: "<strong>Звільніть простір без стресу</strong>.",
    ABOUT_US_CHAPTER_3_PARAGRAPH_2:
      "Старі меблі, електроприлади чи зламані речі? Що б вам не потрібно було утилізувати, ми подбаємо про це <strong>екологічно та професійно</strong>. Чи то після переїзду, прибирання будинку, чи то через необхідність додаткового простору – ми подбаємо про належну утилізацію всього.",
    ABOUT_US_CHAPTER_4_TITLE: "ПРО HEGI UMZÜGE",
    ABOUT_US_CHAPTER_4_PARAGRAPH_1:
      "Ми — молода, енергійна команда, яка прагне стати надійним партнером у сфері переїздів. Хоча ми були засновані нещодавно, ми маємо багатий досвід роботи з провідними компаніями галузі. Ми знаємо, як організувати переїзд так, щоб він був швидким, безпечним та безстресовим для наших клієнтів.",
    ABOUT_US_CHAPTER_4_PARAGRAPH_2:
      "Заснувавши власну компанію, ми поєднали передовий досвід та ідеї, щоб вивести наші послуги на новий рівень. Наша мета — не просто перевезти речі, а дати людям впевненість та безпеку у вирішальний етап їхнього життя. Ми ростемо, навчаємося та вдосконалюємося щодня — на благо тих, хто довіряє нам свій переїзд.",
    SHOW_MY_ORDERS: "показати мої замовлення",
    HIDE_MY_ORDERS: "приховати мої замовлення",
    QR_CODE_TO_GO_TO_THIS_SITE: "QR-код для переходу на цей сайт",
    ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED:
      "усі послуги, що належать до цієї категорії, будуть видалені",
    THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED:
      "замовлення не може бути оновлене, оскільки воно вже виконане",
    CHANGE_OF_STATUS: "зміна статусу",
    THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW:
      "Статус замовлення — «{{current}}». Ви впевнені, що хочете змінити його на «{{new}}»?",
    CHANGE_PAYMENT_STATUS: "змінити статус оплати",
    PAYMENT_STATUS_CHANGE: "зміна статусу оплати",
    PAYMENT_STATUS_CHANGED: "статус оплати змінився",
    FAILED_TO_CHANGE_PAYMENT_STATUS: "не вдалося змінити статус оплати",
    MOST_LIKELY_IT_WAS_DELETED: "найімовірніше, його видалили",
    SETTINGS: "налаштування",
    CLOSE: "закрити",
    CONSENT_MODAL_TITLE: "ми використовуємо файли cookie",
    CONSENT_MODAL_DESCRIPTION:
      "Ми використовуємо файли cookie для роботи нашого веб-сайту, а також для відображення та аналізу реклами через Google Ads. Завжди використовуються основні файли cookie. Усі інші файли cookie використовуються лише з вашої згоди. Ви можете прийняти всі файли cookie, відхилити додаткові або налаштувати свої налаштування.",
    CONSENT_MODAL_ACCEPT_ALL: "прийняти всі",
    CONSENT_MODAL_ACCEPT_NECESSARY: "прийняти лише необхідні",
    CONSENT_PREFERENCES_MODAL_TITLE: "налаштування файлів cookie",
    CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES: "прийняти",
    CONSENT_PREFERENCES_MODAL_SERVICE: "сервіс(и)",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE: "необхідні",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION:
      "Ці файли cookie є необхідними для коректної роботи вебсайту, наприклад для автентифікації користувачів.",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE: "аналітика",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION:
      "Файли cookie, що використовуються для аналітики, допомагають збирати дані, які дозволяють сервісам розуміти, як користувачі взаємодіють із певним сервісом.",
    CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE:
      "Дозволяє зберігання даних (наприклад, файлів cookie), пов’язаних з аналітикою, таких як тривалість вашого відвідування.",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE: "реклама",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION:
      "Google використовує файли cookie для рекламних цілей, зокрема для показу та доставки реклами, персоналізації реклами, обмеження кількості показів реклами, вимкнення небажаної реклами, а також для вимірювання ефективності реклами.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE:
      "Дозволяє зберігання даних (наприклад, файлів cookie), пов’язаних із рекламою.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA:
      "Дозволяє надсилання користувацьких даних, пов’язаних із рекламою, до Google.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION:
      "Дозволяє використання даних для персоналізованої реклами.",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE: "функціональність",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION:
      "Функціональні файли cookie дозволяють користувачам взаємодіяти із сервісом або вебсайтом та отримувати доступ до функцій, необхідних для роботи цього сервісу.",
    CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE:
      "Дозволяє зберігання даних, що підтримують функціональність вебсайту або застосунку, наприклад мовних налаштувань.",
    CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE:
      "Дозволяє зберігання даних, пов’язаних із персоналізацією, наприклад рекомендацій.",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE: "безпека",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION:
      "Файли cookie, що використовуються з метою безпеки, наприклад для автентифікації користувачів, запобігання шахрайству та захисту користувачів під час взаємодії із сервісом.",
    CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE:
      "Дозволяє зберігання даних, пов’язаних із безпекою, таких як дані для автентифікації, запобігання шахрайству та інші функції захисту користувачів.",
    THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS:
      "Мова сторінки змінилася, але вміст діалогового вікна cookie оновиться лише після перезавантаження сторінки.",
    IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS:
      "Якщо вас не цікавить вміст діалогового вікна cookie, ви можете проігнорувати це повідомлення.",
    RELOAD_PAGE: "перезавантажити сторінку",
    CONSENT_SUMMARY_TITLE: "статус згоди на обробку даних",
    CONSENT_SUMMARY_DESCRIPTION:
      "Короткий огляд поточного статусу вашої згоди. Детальна інформація доступна в налаштуваннях.",
    CONSENT_ID: "ID згоди",
    LAST_MODIFIED: "останнє оновлення",
    CONSENT_SUMMARY_ALLOWED: "дозволено",
    CONSENT_SUMMARY_PARTIALLY_ALLOWED: "частково дозволено",
    CONSENT_SUMMARY_BLOCKED: "заблоковано",
  } satisfies Record<Tk, string>,
} satisfies ResourceLanguage;

export { RESOURCES };
